import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import TimelineIcon from '@mui/icons-material/Timeline';

/**
 * Analiz / Trend tab switcher for report detail views
 */
const ReportViewTabs = ({ activeTab, onChange }) => (
  <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
    <Tabs
      value={activeTab}
      onChange={(_, v) => onChange(v)}
      textColor="primary"
      indicatorColor="primary"
    >
      <Tab value="analysis" label="Analiz" icon={<AnalyticsIcon />} iconPosition="start" />
      <Tab value="trend" label="Trend" icon={<TimelineIcon />} iconPosition="start" />
    </Tabs>
  </Box>
);

export default ReportViewTabs;
